import { defineStore } from "pinia";

export const useSite = defineStore("site", {
  state: () => ({
    id: null,

    name: null,
    customers: null,
    imageUrl: null,
    stores: null,
    paymentMethods: null,

    loading: true,
    notFound: false,

    gtmReference: useState("gtm-reference"),
    takeawayPromotions: [],
  }),

  actions: {
    async load(data) {
      this.name = data.name;
      this.gtmReference = data.gtm_reference;
      this.customers = data.customers;
      this.imageUrl = data.image_url;
      this.stores = data.stores;
      this.takeawayPromotions = data.takeaway_promotions;
    },
  },
});
